import React from 'react';
import {FormattedMessage} from 'react-intl';

import musicIconURL from './music/music.png';
import musicInsetIconURL from './music/music-small.svg';

import penIconURL from './pen/pen.png';
import penInsetIconURL from './pen/pen-small.svg';

import videoSensingIconURL from './videoSensing/video-sensing.png';
import videoSensingInsetIconURL from './videoSensing/video-sensing-small.svg';

import text2speechIconURL from './text2speech/text2speech.png';
import text2speechInsetIconURL from './text2speech/text2speech-small.svg';

import translateIconURL from './translate/translate.png';
import translateInsetIconURL from './translate/translate-small.png';

import makeymakeyIconURL from './makeymakey/makeymakey.png';
import makeymakeyInsetIconURL from './makeymakey/makeymakey-small.svg';

import microbitIconURL from './microbit/microbit.png';
import microbitInsetIconURL from './microbit/microbit-small.svg';
import microbitConnectionIconURL from './microbit/microbit-illustration.svg';
import microbitConnectionSmallIconURL from './microbit/microbit-small.svg';

import ev3IconURL from './ev3/ev3.png';
import ev3InsetIconURL from './ev3/ev3-small.svg';
import ev3ConnectionIconURL from './ev3/ev3-hub-illustration.svg';
import ev3ConnectionSmallIconURL from './ev3/ev3-small.svg';

import wedo2IconURL from './wedo2/wedo.png'; // TODO: Rename file names to match variable/prop names?
import wedo2InsetIconURL from './wedo2/wedo-small.svg';
import wedo2ConnectionIconURL from './wedo2/wedo-illustration.svg';
import wedo2ConnectionSmallIconURL from './wedo2/wedo-small.svg';
import wedo2ConnectionTipIconURL from './wedo2/wedo-button-illustration.svg';

import boostIconURL from './boost/boost.png'; 
import boostInsetIconURL from './boost/boost-small.svg';
import boostConnectionIconURL from './boost/boost-illustration.svg';
import boostConnectionSmallIconURL from './boost/boost-small.svg';
import boostConnectionTipIconURL from './boost/boost-button-illustration.svg';

import gdxforIconURL from './gdxfor/gdxfor.png';
import gdxforInsetIconURL from './gdxfor/gdxfor-small.svg';
import gdxforConnectionIconURL from './gdxfor/gdxfor-illustration.svg';
import gdxforConnectionSmallIconURL from './gdxfor/gdxfor-small.svg';

import faceDetectionIconURL from './faceDetection/faceDetection.png';
import faceDetectionInsetIconURL from './faceDetection/faceDetection-small.png';

import objectDetectionIconURL from './objectDetection/objectDatection.png';
import objectDetectionInsetIconURL from './objectDetection/objectDatection-small.png';

import posenetIconURL from './posenet/bodyDetection.png';
import posenetInsetIconURL from './posenet/bodyDetection-small.png';

import handposenetIconURL from './handposenet/handDetection.png';
import handposenetInsetIconURL from './handposenet/handDetection-small.png';

import weatherdataIconURL from './weatherdata/weather.png';
import weatherdataInsetIconURL from './weatherdata/weather-small.png';

import wikipediaIconURL from './wikipedia/wikipedia.png';
import wikipediaInsetIconURL from './wikipedia/wikipedia-small.png';

import teachableMachineIconURL from './teachableMachine/teachableMachine.png';
import teachableMachineInsetIconURL from './teachableMachine/teachableMachine-small.png';

import TMPose2ScratchIconURL from './tmpose2scratch/tmpose2scratch.png';
import TMPose2ScratchInsetIconURL from './tmpose2scratch/tmpose2scratch-small.png';

import TM2ScratchIconURL from './tm2scratch/tm2scratch.png';
import TM2ScratchInsetIconURL from './tm2scratch/tm2scratch-small.png';

import Speech2ScratchIconURL from './speech2scratch/spench2scratch.png';
import Speech2ScratchInsetIconURL from './speech2scratch/spench2scratch-small.png';

export default [
    {
        name: (
            <FormattedMessage
                defaultMessage="Music"
                description="Name for the 'Music' extension"
                id="gui.extension.music.name"
            />
        ),
        extensionId: 'music',
        iconURL: musicIconURL,
        insetIconURL: musicInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Play instruments and drums."
                description="Description for the 'Music' extension"
                id="gui.extension.music.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Pen"
                description="Name for the 'Pen' extension"
                id="gui.extension.pen.name"
            />
        ),
        extensionId: 'pen',
        iconURL: penIconURL,
        insetIconURL: penInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Draw with your sprites."
                description="Description for the 'Pen' extension"
                id="gui.extension.pen.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Video Sensing"
                description="Name for the 'Video Sensing' extension"
                id="gui.extension.videosensing.name"
            />
        ),
        extensionId: 'videoSensing',
        iconURL: videoSensingIconURL,
        insetIconURL: videoSensingInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Sense motion with the camera."
                description="Description for the 'Video Sensing' extension"
                id="gui.extension.videosensing.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Text to Speech"
                description="Name for the Text to Speech extension"
                id="gui.extension.text2speech.name"
            />
        ),
        extensionId: 'text2speech',
        collaborator: 'Amazon Web Services',
        iconURL: text2speechIconURL,
        insetIconURL: text2speechInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Make your projects talk."
                description="Description for the Text to speech extension"
                id="gui.extension.text2speech.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Translate"
                description="Name for the Translate extension"
                id="gui.extension.translate.name"
            />
        ),
        extensionId: 'translate',
        collaborator: 'Google',
        iconURL: translateIconURL,
        insetIconURL: translateInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Translate text into many languages."
                description="Description for the Translate extension"
                id="gui.extension.translate.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },

    {
        name: (
            <FormattedMessage
                defaultMessage="Face Detection"
                description="Pinoo face detection extension"
                id="gui.extension.faceDetection.name"
            />
        ),
        extensionId: 'faceDetection',
        iconURL: faceDetectionIconURL,
        insetIconURL: faceDetectionInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect and recognize human faces."
                description="Detect and recognize human faces"
                id="gui.extension.faceDetection.description"
            />
        ),
        featured: true
    },    

    {
        name: (
            <FormattedMessage
                defaultMessage="Pinoo object detection extension."
                description="Pinoo object detection extension"
                id="gui.extension.objectDetection.name"
            />
        ),
        extensionId: 'objectDetection',
        iconURL: objectDetectionIconURL,
        insetIconURL: objectDetectionInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect and recognize objects."
                description="Detect and recognize objects"
                id="gui.extension.objectDetection.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Human Body Parts Detection"
                description="Pinoo human body part detection extension"
                id="gui.extension.posenet.name"
            />
        ),
        extensionId: 'posenet',
        iconURL: posenetIconURL,
        insetIconURL: posenetInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect and recognize human body parts."
                description="Detect and recognize human body parts"
                id="gui.extension.posenet.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Human Hand Detection"
                description="Human hand detection extension"
                id="gui.extension.handposenet.name"
            />
        ),
        extensionId: 'handposenet',
        iconURL: handposenetIconURL,
        insetIconURL: handposenetInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect and recognize human hands."
                description="Detect and recognize human hands"
                id="gui.extension.handposenet.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Weather Data"
                description="Weather Data extension"
                id="gui.extension.weatherdata.name"
            />
        ),
        extensionId: 'weatherdata',
        iconURL: weatherdataIconURL,
        insetIconURL: weatherdataInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Get weather data of a location."
                description="Get weather data of a location"
                id="gui.extension.weatherdata.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Wikipedia"
                description="Wikipedia"
                id="gui.extension.wikipedia.name"
            />
        ),
        extensionId: 'wikipedia',
        iconURL: wikipediaIconURL,
        insetIconURL: wikipediaInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Ask to Wikipedia."
                description="Ask to Wikipedia"
                id="gui.extension.wikipedia.description"
            />
        ),
        featured: true
    },

    {
        name: (
            <FormattedMessage
                defaultMessage="Teachable Machine"
                description="Teachable Machine"
                id="gui.extension.teachableMachine.name"
            />
        ),
        extensionId: 'teachableMachine',
        iconURL: teachableMachineIconURL,
        insetIconURL: teachableMachineInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Group objects using TM."
                description="Group objects using TM"
                id="gui.extension.teachableMachine.description"
            />
        ),
        featured: true
    },

    {
        name: (
            <FormattedMessage
                defaultMessage="TM Pose to Scratch"
                description="TMPose2Scratch"
                id="gui.extension.TMPose2Scratch.name"
            />
        ),
        extensionId: 'tmpose2scratch',
        iconURL: TMPose2ScratchIconURL,
        insetIconURL: TMPose2ScratchInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect and recognize human body parts using TM."
                description="Detect and recognize human body parts using TM"
                id="gui.extension.TMPose2Scratch.description"
            />
        ),
        featured: true
    },

    {
        name: (
            <FormattedMessage
                defaultMessage="TM to Scratch"
                description="TM2Scratch"
                id="gui.extension.TM2Scratch.name"
            />
        ),
        extensionId: 'tm2scratch',
        iconURL: TM2ScratchIconURL,
        insetIconURL: TM2ScratchInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Detect and recognize using TM using TM."
                description="Detect and recognize using TM using TM"
                id="gui.extension.TM2Scratch.description"
            />
        ),
        featured: true
    },

    {
        name: (
            <FormattedMessage
                defaultMessage="Speech to Scratch"
                description="Speech2Scratch"
                id="gui.extension.Speech2Scratch.name"
            />
        ),
        extensionId: 'speech2scratch',
        iconURL: Speech2ScratchIconURL,
        insetIconURL: Speech2ScratchInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Convert Speech to Text."
                description="Convert Speech to Text"
                id="gui.extension.Speech2Scratch.description"
            />
        ),
        featured: true
    }
];
